import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Table, ConfigProvider, Button, Space, Modal, message, Tag, Spin, Select } from 'antd';
import { SearchOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { hnrequest } from '@/utils'
import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';


const Aqymb = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [formxf] = Form.useForm();
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [bangm, setbangm] = useState([]);

  const [ticks, setticks] = useState([]);
  const [spinning, setSpinning] = useState(false);




  useEffect(() => {
    setSpinning(true)
    async function getau() {
      const res = await hnrequest.post('/pms_qyms')
      setbangm(res.rescode)
      setSpinning(false)
    }
    getau()
  }, [ticks])

  const onFxfsq = async (e) => {
    const rq = await hnrequest.post('/p_adqms', e)
    setOpen(false)
    setticks(rq.ticks)
    messageApi.open({ type: rq.return_code, content: rq.return_msg, });
  }

  const addqms = () => {
    setOpen(true)
  }


  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });












  const columns = [

    {
      title: <Button type="dashed" onClick={() => addqms()}> + 添加企业信息</Button>,
      dataIndex: 'key',
      key: 'key',
      ...getColumnSearchProps('key'),
      render: (_, records) => (
        <>{records.key}</>
      ),

    },
    {
      title: '名称',
      dataIndex: 'pname',
      key: 'pname',
      ...getColumnSearchProps('pname'),
    },


    {
      title: '标签',
      key: 'tags',
      ...getColumnSearchProps('tags'),
      dataIndex: 'tags',
      render: (_, { tags }) => (
        <>
          {tags && tags.map((tag) => {
            let color = tag.length > 5 ? 'geekblue' : 'green';
            if (tag === 'loser') {
              color = 'volcano';
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },

    {
      title: '简拼代码',
      key: 'nydjz',
      ...getColumnSearchProps('nydjz'),
      dataIndex: 'nydjz',
    },


  ];
  // 




  return (
    <>

      <ConfigProvider locale={zhCN} >
        {contextHolder}

        <div >
          <Form form={form} component={false}>

            <Table size="small"
              columns={columns} dataSource={bangm} />

          </Form>
        </div>



        {/*  */}
        <Modal
          title="添加生产企业信息"
          footer={null}
          style={{ top: 98 }}
          open={open}
          // onOk={() => onFxfsq()}
          onCancel={() => setOpen(false)}
          width={1000}
        >

          <Form
            name="dbxfsq"
            layout="horizontal"
            onFinish={onFxfsq}
            form={formxf}
          >
            <Form.Item
              label="企业名称"
              name="qname"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder='仅用于查询检索、选中企业及生成简拼代码，不对外展示' allowClear />
            </Form.Item>

            <Form.Item
              label=""
              name="tags"
            >

              <Select
                mode="tags"
                style={{
                  width: '100%',
                }}
                tokenSeparators={[',']}
                placeholder='标签，方便查询检索，不对外展示'

              />
            </Form.Item>


            <Form.List name="qmsjson" >


              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                      <Form.Item
                        {...restField}
                        name={[name, 'title']}
                        rules={[{ required: true, message: '标题不可为空!' }]}
                      >
                        <Input placeholder="标题" allowClear />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'qcont']}
                        rules={[{ required: true, message: '内容不可为空！' }]}
                      >
                        <Input placeholder="内容" style={{ width: "700px" }} count={{ show: true, }} allowClear />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                      添加结构
                    </Button>
                  </Form.Item>
                </>
              )}





            </Form.List>

            <Form.Item>
              <Button type="primary"
                htmlType="submit"
                style={{ marginTop: "20px" }}
                block={true} >
                提   交
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        {/*  */}


        <Spin spinning={spinning} tip="数据整理中，请稍等..." fullscreen />
      </ConfigProvider>
    </>

  );
};
export default Aqymb;